import { createElement } from "react";
import type { RouteObject } from "react-router";
import RootRoute from "./RootRoute";
import RouteErrorFallback from "./RouteErrorFallback";

export const appRoutes = [
  {
    path: "*",
    element: createElement(RootRoute),
    errorElement: createElement(RouteErrorFallback)
  }
] satisfies RouteObject[];
